// This file can be replaced during build by using env-specific imports.
// The list of file replacements can be configured in vite.config.ts.

const apiResourceBase = import.meta.env.VITE_apiResourceBase || 'http://localhost:50225/';

const apiBaseUrl = import.meta.env.VITE_apiBaseUrl || 'http://localhost:8000/api/v2';
const footerSupportUrl = import.meta.env.VITE_footerSupportUrl || 'https://support.kpmg.com';
const footerVersion = import.meta.env.VITE_footerVersion;
const syncfusionLicenseKey = import.meta.env.VITE_syncfusionLicenseKey;

const fallbackClientId = '294de199-96ec-4e0a-8629-7705430dc3cb';
const fallbackAuthority = 'https://login.microsoftonline.com/cf59843c-25a6-4e9e-a632-73d41e867a1f';
const fallbackApiScope = 'https://kciapi.dev.kpmgdev.com/.default';

const sanitizeEnv = (value: string | undefined): string | undefined => {
  if (!value) return undefined;
  const trimmed = value.trim();
  if (!trimmed) return undefined;
  if (
    trimmed.toLowerCase() === 'undefined' ||
    trimmed.toLowerCase() === 'null' ||
    /^\$[^$]+\$$/.test(trimmed)
  ) return undefined;
  return trimmed;
};

const aadClientId = sanitizeEnv(import.meta.env.VITE_aadClientId) || fallbackClientId;
const aadAuthority = sanitizeEnv(import.meta.env.VITE_aadAuthority) || fallbackAuthority;
const aadApiScope = sanitizeEnv(import.meta.env.VITE_aadApiScope) || fallbackApiScope;
const aadRedirectUri =
  sanitizeEnv(import.meta.env.VITE_aadRedirectUri) ||
  (typeof window !== 'undefined' ? `${window.location.origin}/` : 'http://localhost:4200/');
const aiIntegrationId =
  sanitizeEnv(import.meta.env.VITE_aiintegrationId) ||
  sanitizeEnv(import.meta.env.VITE_notificationIntegrationId) ||
  sanitizeEnv(import.meta.env.VITE_claraAiIntegrationId) ||
  '';

// Shared with the ClaraAI remote, which reads this key from sessionStorage on init.
export const AI_INTEGRATION_ID_STORAGE_KEY = 'aiintegrationid';
export const FALLBACK_AI_INTEGRATION_ID = aiIntegrationId;
export function getStoredAiIntegrationId(): string | undefined {
  if (typeof window === 'undefined') return undefined;
  return sanitizeEnv(window.sessionStorage.getItem(AI_INTEGRATION_ID_STORAGE_KEY) ?? undefined);
}


export const environment = {
  production: false,
  FooterLinkText: 'home.kpmg/governance.',
  FooterLink_URL: footerSupportUrl,
  FooterVersion: footerVersion,
  DisplayYear: '2026',
  clientID: aadClientId,
  get aiIntegrationId(): string {
    return getStoredAiIntegrationId() || aiIntegrationId;
  },
  apiBaseUrl: apiBaseUrl,
  authority: aadAuthority,
  // Use current origin so it works for both dev (4200) and preview (4173) modes
  // NOTE: Both URIs must be registered in Azure AD app registration
  redirectUri: aadRedirectUri,

  protectedResourceMap: [
    ['https://graph.microsoft.com/v1.0/me', ['user.read']],
    [apiResourceBase, [aadApiScope]],
  ] as [string, string[]][],
  apiScope: aadApiScope,
  

  interactionType: 'redirect',
  SyncfusionLicenseKey: sanitizeEnv(syncfusionLicenseKey) || '',
  PrimeNGLicenseKey: '',
  graphPhotoConfig: {
    url: 'https://graph.microsoft.com/v1.0/me/photo/$value',
    scope: ['User.Read'],
  },
  agentStudioAPIBase:
    'https://audeusdev-retjsonformatter.azurewebsites.net',
  ClientConfidentialInfoUrl: 'https://kieps.kpmg.com/gdpsp-readonly',
};
